import { render, staticRenderFns } from "./k-flip-button.vue?vue&type=template&id=1c6dd376&scoped=true"
import script from "./k-flip-button.vue?vue&type=script&lang=js"
export * from "./k-flip-button.vue?vue&type=script&lang=js"
import style0 from "./k-flip-button.vue?vue&type=style&index=0&id=1c6dd376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6dd376",
  null
  
)

export default component.exports